import Dashboard from "./dashboard/dashboard";
import Jobs from "./jobs/jobs";
import Todo from "./todo/todo";
import Users from "./users/users";
import UserDocument from "./users/userDocument";
import Roles from "./users/Roles";
import Rota from "./users/Rota";
import MyRota from "./users/MyRota";
import HelpMatManage from "./users/HelpMatManage";
import Resources from "./resources/resources";
import Leave from "./leave/leave";
import Attendence from "./attendence/attendence";
import Evidences from "./evidences/evidences";
import MyProfile from "./users/myprofile";
import HelpMaterials from "./helpmaterials/helpmaterials";
import Reports from "./reports/reports";
import Logout from "./logout";
import CqcDashboard from './cqc/cqcDashboard';
import DocViewer from './cqc/DocViewer';

export default {
  Dashboard,
  Jobs,
  Todo,
  Resources,
  UserDocument,
  CqcDashboard,
  DocViewer,
  Leave,
  Attendence,
  Evidences,
  HelpMaterials,
  Reports,
  Users,
  Roles,
  Rota,
  MyRota,
  HelpMatManage,
  MyProfile,
  Logout,
};
